/* 
 * Export component file to be used on project
*/

import StickyIndex from './StickyIndex.js';
export default StickyIndex;
